import { render } from "./VSelect2.vue?vue&type=template&id=17b9ed59"
import script from "./VSelect2.vue?vue&type=script&lang=js"
export * from "./VSelect2.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__